import {
  FormControl,
  FormLabel,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Box,
  Text,
} from "@chakra-ui/react";
import React from "react";

const MySlider = ({ label, value, onChange, required }) => {
  return (
    <FormControl isRequired={required}>
      <FormLabel>{label}</FormLabel>
      <RangeSlider
        mt={2.5}
        aria-label={["min", "max"]}
        defaultValue={[1000, 5000]}
        min={0}
        max={10000}
        // step={500}
        value={[
          Number(value[0]) ? Number(value[0]) : 0,
          Number(value[1]) ? Number(value[1]) : 0,
        ]}
        onChange={onChange}
        colorScheme="teal"
      >
        <RangeSliderTrack>
          <RangeSliderFilledTrack />
        </RangeSliderTrack>
        <RangeSliderThumb index={0}>
          <Box
            color="teal.600"
            fontWeight="bold"
            fontSize="xs"
            position="absolute"
            bottom="-24px"
          >
            <Text>{value[0]}</Text>
          </Box>
        </RangeSliderThumb>
        <RangeSliderThumb index={1}>
          <Box
            color="teal.600"
            fontWeight="bold"
            fontSize="xs"
            position="absolute"
            bottom="-24px"
          >
            <Text>{value[1]}</Text>
          </Box>
        </RangeSliderThumb>
      </RangeSlider>
    </FormControl>
  );
};

export default MySlider;
